export default __webpack_public_path__ + "static/media/jenkins-project-icon.d766edc7.svg";